import * as React from 'react';

const Scroll: React.FC = (props) => (
	<svg
		width={328}
		height={219}
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<path
			d='M327.29 191.665s3.11 21.57-21.281 25.925c-21.827 3.896-31.715-4.961-32.621-13.991-1.708-16.998 1.31-38.449 17.118-40.577 37.455-5.053 36.784 28.643 36.784 28.643Z'
			fill='#A38F7B'
		/>
		<path
			d='M309.048 194.022s.257 8.578-2.657 11.339c-6.908 6.548-19.132 5.669-19.132 5.669l-1.598-21.968H307.1l1.948 4.96Z'
			fill='#AF9981'
		/>
		<path
			d='m309.048 167.987-.213 30.487s-1.44-10.679-19.715-8.267c-16.13 2.128-15.705 13.396-15.705 13.396l-4.228-23.747 39.861-11.869Z'
			fill='#D5AE87'
		/>
		<path
			d='M.404 191.665s-3.116 21.57 21.281 25.925c21.827 3.896 31.71-4.961 32.62-13.991 1.709-16.998-1.309-38.449-17.117-40.577C-.272 157.969.404 191.665.404 191.665Z'
			fill='#A38F7B'
		/>
		<path
			d='M18.673 194.022s-.257 8.578 2.657 11.339c6.909 6.548 19.132 5.669 19.132 5.669l1.593-21.968H20.594l-1.921 4.96Z'
			fill='#AF9981'
		/>
		<path
			d='m18.673 167.987.213 30.487s1.44-10.679 19.715-8.267c16.125 2.128 15.705 13.396 15.705 13.396l4.201-23.753-39.834-11.863Z'
			fill='#D5AE87'
		/>
		<path
			d='M327.017 26.865S330.002 5.3 305.637.945c-21.827-3.901-31.714 4.96-32.62 13.986-1.708 16.998 1.31 38.448 17.118 40.582 37.428 5.047 36.882-28.648 36.882-28.648Z'
			fill='#A38F7B'
		/>
		<path
			d='M309.135 24.54v-4.48c-.245-2.532-.955-5.456-2.444-6.892-6.909-6.548-19.132-5.67-19.132-5.67l-1.598 21.97H307.4l1.735-4.928Z'
			fill='#AF9981'
		/>
		<path
			d='m309.321 50.553-.213-30.492s-1.441 10.678-19.715 8.267c-16.13-2.123-16.371-13.588-16.371-13.588l-3.563 23.923 39.862 11.89Z'
			fill='#D5AE87'
		/>
		<path
			d='M.666 26.865S-2.45 5.3 21.947.945c21.827-3.901 31.71 4.96 32.62 13.986 1.708 16.998-1.31 38.448-17.117 40.582C0 60.56.666 26.865.666 26.865Z'
			fill='#A38F7B'
		/>
		<path
			d='M19.491 24.431s-1.636-8.37 2.085-11.263C29.106 7.341 40.707 7.5 40.707 7.5l1.594 21.969H20.856L19.49 24.43Z'
			fill='#AF9981'
		/>
		<path
			d='m18.919 50.553.212-30.492s1.441 10.678 19.716 8.267C54.97 26.204 54.55 14.93 54.55 14.93l4.23 23.732-39.862 11.89Z'
			fill='#D5AE87'
		/>
		<path
			d='M327.017 26.865c-.054 1.594-1.189 9.277-18.34 9.277-11.104 0-35.643-8.055-61.372-14.897l-2.554 3.738 4.366 7.759-3.171 6.193-3.585 9.55V29.468l-1.997-2.892 1.293-6.805c-7.879-2.019-15.781-3.858-23.371-5.255l-2.625 3.957v8.114l-1.604-8.114v-4.688a133.684 133.684 0 0 0-19.781-1.948c-22.143-.24-28.691-.163-30.432-.06-1.741-.103-8.283-.18-30.427.06-12.037.137-26.579 2.86-41.335 6.44v8.31l-2.39 12.36v-9.479l-2.395-6.084v-3.94a628.317 628.317 0 0 0-7.176 1.866c-.289 1.326-1.32 6.123-1.32 6.701 0 .671 3.012 2.87 3.012 2.87l-3.722 9.211-2.302 5.85-.884-6.38V33.72l-2.838-4.96v-5.255c-22.574 6.237-43.152 12.638-53.05 12.638-17.15 0-18.291-7.684-18.34-9.277C.644 30.63.31 71.294 0 108.716c.311 37.401.393 78.206.426 81.971.049-1.593 1.44-9.418 18.59-9.418 11.127 0 35.748 8.087 61.531 14.935l-2.019-3.76 3.274-3.355-1.637-5.032 3.541 5.032-1.898 3.355 3.694 5.059c1.913.491 3.829.971 5.746 1.44l-1.905-9.352 4.366-.901v-5.042l-1.992-4.551 1.79-6.744.054 7.023 4.955 4.25-1.997 6.63-2.587 2.374 4.584 7.972c1.179.27 2.356.528 3.531.775v-5.015l3.988-5.866v-4.731l1.992 5.021-2.99 5.576 2.183 6.068c9.38 1.823 18.323 3.018 26.192 3.105 22.143.24 28.686.164 30.427.06 1.74.104 8.288.18 30.432-.06 6.633-.157 13.245-.81 19.781-1.953v-14.521l2.99-5.031-1.495-5.582 4.48 5.582-2.991 5.031v14.03c14.919-2.669 31.158-7.094 46.044-11.296l-6.002-2.728 3.389-5.031 2.597-5.583-2.597-6.379 4.742 6.379-1.354 7.34v3.274l3.989 1.386c17.565-4.949 32.741-9.206 40.806-9.206 17.15 0 18.285 7.683 18.34 9.277.033-3.765.365-44.429.671-81.851-.278-37.38-.611-78.043-.644-81.808Z'
			fill='#E2C19F'
		/>
		<path
			opacity={0.2}
			d='m18.842 181.242-4.55.218-4.72.824.24-147.125 4.228.83 4.977.152-.175 145.101Z'
			fill='#EDEDED'
		/>
		<path
			d='M327.017 26.865s-.12 3.16-4.365 5.877c-2.974 1.92-7.356 2.935-7.356 2.935l3.138 146.699c5.276 1.981 6.799 4.158 8.829 9.277l-.246-164.788Z'
			fill='#D5AE87'
		/>
	</svg>
);

export default Scroll;
